// ** Custom Components
import Block from "components/layout/Block";

// ** Activity Selectors
import useActivityTypeSelector from "./hooks/useActivityTypeSelector";
import useActivityDateSelector from "./hooks/useActivityDateSelector";

// ** Custom Hooks
import useBreakpoint from "hooks/useBreakpoint";

// #####################################################

const Filters = ({ date, type, setType, path }) => {
	const isPhone = useBreakpoint("phone", "max");

	const { renderActivityTypeSelector } = useActivityTypeSelector({
		type,
		setType,
		date,
		path,
	});

	const { renderActivityDateSelector } = useActivityDateSelector({
		date,
		path,
	});

	// #####################################################

	return (
		<Block
			flex
			fullWidth={isPhone}
			flexWrap
			alignEnd={!isPhone}
			alignCenter={!isPhone}
			column={isPhone}
			withRowGap
		>
			{renderActivityTypeSelector()}
			{renderActivityDateSelector()}
		</Block>
	);
};

export default Filters;

// #####################################################
